<template>
  <div>
    <div v-if="cellData.SurveyWave && !cellData.entries" class="waves">
      <div  v-if="cellData.SurveyWave.length > 1 && cellData.SurveyWave[1]"
            class="c0 aw"
            v-bind:style="{ width: getWidth(cellData.SurveyWave[1]) + '%' }"
            v-b-tooltip.hover.nofade="toolTipDelay"
            :title="getActualWaveTooltip(cellData.SurveyWave[1])" />
      <div  v-else-if="cellData.SurveyWave.length === 1 && cellData.SurveyWave[0]"
            class="c0 aw"
            v-bind:style="{ width: getWidth(cellData.SurveyWave[0]) + '%' }"
            v-b-tooltip.hover.nofade="toolTipDelay"
            :title="getActualWaveTooltip(cellData.SurveyWave[0])" />
      <div  v-if="cellData.SurveyWave.length > 1 && cellData.SurveyWave[0]"
            class="c7 lw"
            v-bind:style="{ width: getWidth(cellData.SurveyWave[0]) + '%' }"
            v-b-tooltip.hover.nofade="toolTipDelay"
            :title="getLastWaveTooltip(cellData.SurveyWave[0])" />
      <div  v-if="cellData.KpiFehlartikel">
        <div class="longText">{{cellData.KpiFehlartikel}}</div>
      </div>
      <div  v-else class="now" />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    cellData: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      toolTipDelay: { delay: { "show": 500, "hide": 100 } }
    };
  },

  methods: {
    getColorClass(index, count) {
      switch (count) {
        case 0:
        case 1:
        case 2:
          return index % 2 === 0 ? { c0: true } : { c7: true };
          break;

        case 3:
          if (index % 3 === 0) {
            return { c0: true };
          }
          if (index % 3 === 1) {
            return { c4: true };
          }
          return { c8: true };

          return index % 2 === 0 ? { c0: true } : { c7: true };
          break;

        default:
          if (index % 4 === 0) {
            return { c0: true };
          }
          if (index % 4 === 1) {
            return { c3: true };
          }
          if (index % 4 === 2) {
            return { c6: true };
          }
          return { c9: true };
          break;
      }
    },

    checkValue(it) {
      if (it === undefined || it === null) {
        return false;
      }
      return true;
    },
    getWidth(item) {
      return !item.Result || item.Result === 0 ? 0.1 : item.Result;
    },
    getActualWaveTooltip (item) {
      if (!this.cellData.entries) {
        return this.$t('Webportal.CurrentWave') + ' (' + item.Name + ') ' + item.Result + '%';
      }
      return item.Name + ' ' + item.Result + '%';
    },
    getLastWaveTooltip(item) {
      return this.$t('Webportal.PreviousWave') + ' (' + item.Name + ') ' + item.Result + '%';
    }
  }
};

</script>
<style scoped>


.c0{ background-color: #001e78; }
.c3{ background-color: #C80000; }
.c4{ background-color: #FFB428; }
.c6{ background-color: #4169B9; }
.c7{ background-color: #FFB428; }
.c8{ background-color: #00B4DC; }
.c9{ background-color: #FA8214; }

.waves{
  width: 100%;
  height: 2rem;
}
.lw, .aw, .now {
  height: 1rem;
  margin: 1px;
  border-radius: 3px;
}

.now {
  width: 0%;
}

.longText {
  word-break: break-all;
}

</style>
